export const getTimeAgo = (utcTime: string | number | Date) => {
    if (utcTime === null || utcTime === undefined) return '--';

    const date = new Date(utcTime);
    const now = new Date();
    const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

    const timeFormats = [
        { limit: 3, singular: 'Just Now', plural: 'Just Now', divisor: 1 },
        { limit: 60, singular: 'Sec Ago', plural: 'Secs Ago', divisor: 1 },
        { limit: 3600, singular: 'Min Ago', plural: 'Mins Ago', divisor: 60 },
        { limit: 86400, singular: 'Hour Ago', plural: 'Hours Ago', divisor: 3600 },
        { limit: 604800, singular: 'Day Ago', plural: 'Days Ago', divisor: 86400 },
        { limit: 2419200, singular: 'Week Ago', plural: 'Weeks Ago', divisor: 604800 },
        { limit: 29030400, singular: 'Month Ago', plural: 'Months Ago', divisor: 2419200 },
        { limit: Infinity, singular: 'Year Ago', plural: 'Years Ago', divisor: 29030400 },
    ];

    let i = 0;
    while (i < timeFormats.length) {
        const { limit, singular, plural, divisor } = timeFormats[i];
        if (diffInSeconds < limit) {
            if (i === 0) return singular;
            const value = Math.floor(diffInSeconds / divisor);
            return `${value} ${value > 1 ? plural : singular}`;
        }
        i += 1;
    }
    return '--';
};

const formatToUSDate = (isoString: string) => {
    const date = new Date(isoString);
    return `${date.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' })}`;
};

const formatToUSDateWithTime = (isoString: string) => {
    const date = new Date(isoString);
    return `${date.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' })}, ${date.toLocaleTimeString(
        'en-US',
        { hour: 'numeric', minute: '2-digit', hour12: true },
    )}`;
};

const formatDateWithTimeWithSeconds = (isoString: string) => {
    const date = new Date(isoString);
    const dateStr = date.toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
    });

    const hours = date.getHours() % 12 || 12;
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    const hourStr = hours.toString().padStart(2, '0');

    const timeStr = `${hourStr}:${minutes}:${seconds}`;
    return `${dateStr} ${timeStr}`;
};
const getDiffInSeconds = (dateValue: string, now = new Date()): number => {
    const date1 = new Date(dateValue);
    const date2 = new Date(now);

    const diffInSeconds = Math.floor((date2.getTime() - date1.getTime()) / 1000);
    return diffInSeconds;
};

const getDayDiff = (date1: string, date2: string) => {
    if (!date1 || !date2) return 1;
    const d1 = new Date(date1);
    const d2 = new Date(date2);
    d1.setHours(0, 0, 0, 0);
    d2.setHours(0, 0, 0, 0);
    const diffTime = d2.getTime() - d1.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)); // round up
    return diffDays;
};
export { formatToUSDate, formatToUSDateWithTime, formatDateWithTimeWithSeconds, getDiffInSeconds, getDayDiff };
